import { createFileRoute, Navigate, Outlet } from '@tanstack/react-router';

import { useFeatureFlags } from '@/components/providers/FeatureFlagsProvider';

export const Route = createFileRoute(
  '/_root/integrations/monitoring/datadog-api-credentials',
)({
  component: RouteComponent,
  beforeLoad: ({ context: { formatMessage } }) => ({
    title: formatMessage({
      id: 'integrations.monitoring.datadog.title',
    }),
  }),
});

function RouteComponent() {
  const { FeatureDatadogIntegration } = useFeatureFlags();

  if (FeatureDatadogIntegration !== true) {
    return <Navigate to="/integrations" />;
  }

  return <Outlet />;
}
